export const SELECT_TRANSFER_CHANGE = 'SELECT_TRANSFER_CHANGE'

export const onSelectDeliveryTransferChange = selectedTransferencia => {
  return {
    type: SELECT_TRANSFER_CHANGE,
    selectedTransferencia,
  }
}
